/** @format */

import React from 'react';
import './styles.scss';
import Button from 'react-bootstrap/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faLongArrowRight,
  faLongArrowLeft
} from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import { getImagePosition } from 'utils/layout';

export default function ServiceContentLayout({
  banner,
  subIcon,
  subIcon1,
  text,
  isMobileView,
  children = null,
  LeadsForm = <></>,
  MainTextContent = <></>
}) {
  const getClassNameSection = isMobileView
    ? 'mobile-articlepage-section'
    : 'articlepage-section';

  function getBtnColor(index) {
    let buttonColor = 'btn-white';
    if (index == 1) {
      buttonColor = 'btn-pink';
    }

    return buttonColor;
  }

  const ParagraphHeading = ({ text = null }) => {
    if (text) {
      return (
        <div className='heading-container'>
          <p className='text1'>{text}</p>
        </div>
      );
    }

    return <></>;
  };

  const ParagraphBody = ({ text = null, className = 'text2r' }) => {
    if (text) {
      const seperatedDesc = text.split('\n');

      return seperatedDesc.map((paragraph, index) => (
        <p key={index} className={className}>
          {paragraph}
        </p>
      ));
    }

    return <></>;
  };

  // const DesktopDescriptionView = ({ index, props, heading, articleText }) => {
  //   if (index === 0) {
  //     return (
  //       <>
  //         <img className='top-image' src={subIcon} alt={props.alt} />
  //         <div
  //           className={`${getClassNameSection} articlepage-text-bottom-spacing`}>
  //           <div className='description-heading-wrapper second-description-heading-wrapper'>
  //             <div className='text-section-container'>
  //               <ParagraphHeading text={heading?.text} />
  //               <ParagraphBody
  //                 text={articleText}
  //                 className={`text2r articlepage-text-${getImagePosition(
  //                   props.imagePosition
  //                 )}-spacing`}
  //               />
  //             </div>
  //           </div>
  //         </div>
  //       </>
  //     );
  //   } else {
  //     return (
  //       <div
  //         className={`${getClassNameSection} articlepage-text-bottom-spacing`}>
  //         {props.imagePosition === 'left' && (
  //           <img className='left-image' src={subIcon1} alt={props.alt} />
  //         )}

  //         <div className='description-heading-wrapper'>
  //           <div className='text-section-container'>
  //             <ParagraphHeading text={heading?.text} />
  //             <ParagraphBody
  //               text={articleText}
  //               className={`text2r articlepage-text-${getImagePosition(
  //                 props.imagePosition
  //               )}-spacing`}
  //             />
  //           </div>
  //         </div>
  //         {props.imagePosition === 'right' && (
  //           <img className='right-image' src={subIcon} alt={props.alt} />
  //         )}
  //       </div>
  //     );
  //   }
  // };

  return (
    <div className='articlepage-container'>
      <div className='articlepage'>
        <div className='main-image-container'>
          <div className='image-over-content'>
            <MainTextContent />
            <LeadsForm />
          </div>
          <img
            src={banner}
            className='articlepage image-article-page-1'
            alt='header image'
          />
        </div>
        <div className='text-section-container'>
          <ParagraphHeading text={text?.headings?.main_para} />
          <ParagraphBody text={text?.main_para} />
        </div>
      </div>

      {text?.descriptions &&
        text.descriptions.map(({ text: articleText, props, heading }, key) => (
          <div key={key}>
            {isMobileView ? (
              <div
                className={`${getClassNameSection} articlepage-text-bottom-spacing`}>
                <img
                  src={`${key > 0 ? subIcon1 : subIcon}`}
                  className='mobile-articlepage-image-spacing'
                  alt={props.alt}
                />

                <ParagraphHeading text={heading?.text} />
                <ParagraphBody text={articleText} />
              </div>
            ) : (
              <div
                className={`${getClassNameSection} articlepage-text-bottom-spacing`}>
                {props.imagePosition === 'left' && (
                  <img src={subIcon1} alt={props.alt} />
                )}
                <div className='description-heading-wrapper'>
                  <ParagraphHeading text={heading?.text} />
                  <ParagraphBody
                    text={articleText}
                    className={`text2r articlepage-text-${getImagePosition(
                      props.imagePosition
                    )}-spacing`}
                  />
                </div>
                {props.imagePosition === 'right' && (
                  <img src={subIcon} alt={props.alt} />
                )}
              </div>
            )}
          </div>
        ))}

      {/* {text?.descriptions &&
        text.descriptions.map(({ text: articleText, props, heading }, key) => (
          <div key={key}>
            {isMobileView ? (
              <div
                className={`${getClassNameSection} articlepage-text-bottom-spacing`}>
                <img
                  src={`${key > 0 ? subIcon1 : subIcon}`}
                  className='mobile-articlepage-image-spacing'
                  alt={props.alt}
                />

                <div className='text-section-container'>
                  <ParagraphHeading text={heading?.text} />
                  <ParagraphBody text={articleText} />
                </div>
              </div>
            ) : (
              <DesktopDescriptionView
                index={key}
                props={props}
                heading={heading}
                articleText={articleText}
              />
            )}
          </div>
        ))} */}

      <div className='articlepage-desc text-section-container'>
        <ParagraphHeading text={text?.headings?.second_para} />
        <ParagraphBody text={text?.second_para} />
      </div>
      <div className='mobile-articlepage-desc text-section-container'>
        <ParagraphHeading text={text?.headings?.second_para} />
        <ParagraphBody text={text?.second_para} />
      </div>
      <div
        className={`${
          isMobileView
            ? 'mobile-articlepage-section-buttons'
            : 'articlepage-section-buttons'
        }`}>
        {text?.buttons !== undefined &&
          text.buttons.map((button, index) => (
            <div key={index}>
              <div
                className={`button-container ${
                  isMobileView
                    ? 'mobile-articlepage-button'
                    : 'articlepage-button-spacing-right'
                }`}>
                <Link to={button.url}>
                  <Button
                    className={`btn ${getBtnColor(index)} ${
                      isMobileView && 'mobile-articlepage-fullwidth-buttons'
                    }`}>
                    {index === 0 && (text.id === 2 || text.id === 3) && (
                      <FontAwesomeIcon icon={faLongArrowLeft} size='lg' />
                    )}

                    {button.text}
                    {(index === 1 || index === 2) &&
                      (text.id === 1 || text.id === 2) && (
                        <FontAwesomeIcon icon={faLongArrowRight} size='lg' />
                      )}
                  </Button>
                </Link>
              </div>
            </div>
          ))}

        {children}
      </div>
    </div>
  );
}
